import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MonModalService } from '../services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';


@Directive({
    selector: '[monModalPrompt]',
    standalone: false,
})
export class ModalPromptDirective {
    @Input('monModalPrompt') confirmMessage: string = '';
    // eslint-disable-next-line
    @Output('monModalPromptAction') actionOK = new EventEmitter<string>();
    @Output('monModalPromptActionCancel') actionCancel = new EventEmitter<void>();
    constructor (private monModalService: MonModalService, private translateService: TranslateService) {}

    @HostListener('click')
    onClick (event: Event): void {
        const msg = this.confirmMessage || this.translateService.getString('Are you sure?');

        this.monModalService.prompt(msg, {})
            .then((result) => {
                this.actionOK.emit(result);
            }).catch(() => {
                this.actionCancel.emit();
            });
    }
}
